import { configureStore } from "@reduxjs/toolkit";
import EMenuSlice from "./index";
import UserSlice from "./user";
import TaxSlice from "./tax";
import CompanySlice from "./company_dtl";
import KitchenSlice from "./kitchen_dtl";

const store = configureStore({
  reducer: {
    EMenu: EMenuSlice.reducer,
    User: UserSlice.reducer,
    Company: CompanySlice.reducer,
    Tax: TaxSlice.reducer,
    Kitchen: KitchenSlice.reducer,
  },
});

export default store;
